// @flow
import { post, get } from './common';
import { handleAPIErrors } from '../sentry-util';

export const fetchFeedbackForm = async (session: string) => {
	try {
		const res = await get('/feedback/getForm', {}, { session });
		const { form = {}, success } = res;
		if (!success) {
			throw new Error('Fetching feedback list failed.');
		}
		return form;
	} catch (error) {
		handleAPIErrors(error, '/feedback/getForm');
		throw error;
	}
};

export const submitFeedback = async (
	{
		form,
		orderId,
		userDetails: { name = '', email = '' },
	}: {
		form: { [key: string]: string },
		orderId: string,
		userDetails: {
			name?: string,
			email?: string,
		},
	},
	session: string
) => {
	try {
		const res = await post('/feedback/submit', { form, order_id: orderId, name, email }, { session });
		const { success } = res;
		if (!success) {
			throw new Error('Error while submitting feedback. Please try again');
		}
	} catch (error) {
		handleAPIErrors(error, '/feedback/submit', 'GET', { form, order_id: orderId });
		throw error;
	}
};
